module.exports = __webpack_public_path__ + "img/online_content.3ef77484.png";